import {
  CWD_CHANGED,
  ADD_FOLDER_REQUESTED,
  ADD_FOLDER_REQUEST_FULFILLED,
  ADD_FOLDER_REQUEST_REJECTED,
  UPDATE_FOLDER_REQUEST_FULFILLED,
  GET_FOLDER_REQUESTED,
  GET_FOLDER_REQUEST_FULFILLED,
  GET_FOLDER_REQUEST_REJECTED
} from './const';

// TODO remove this once no one is using it
/**
 * change the current working directory
 * @param {string} folderID - the id of the new cwd
 * @returns {object} an action object
 */
export const changeDir = folderID => ({
  type: CWD_CHANGED,
  folderID
});

/**
 * trigger a request to add a new folder
 * @param {string} folderName - the name of the folder to be added
 * @param {string} parentFolderID - the id of the parent folder
 * @returns {object} an action object
 */
export const addFolder = (folderName, parentFolderID) => ({
  type: ADD_FOLDER_REQUESTED,
  folderName,
  parentFolderID
});

/**
 * handle add folder request failure
 * @param {string} folderName - the name of the folder to be added
 * @param {string} parentFolderID - the id of the parent folder
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const addFolderFailure = (folderName, parentFolderID, error) => ({
  type: ADD_FOLDER_REQUEST_REJECTED,
  folderName,
  parentFolderID,
  error
});

/**
 * handle add folder request success
 * @param {string} folderName - the name of the folder to be added
 * @param {string} parentFolderID - the id of the parent folder
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const addFolderSuccess = (folderName, parentFolderID, payload) => ({
  type: ADD_FOLDER_REQUEST_FULFILLED,
  folderName,
  parentFolderID,
  payload
});

/**
 * handle update folder request success
 * @param {string} folderName - the name of the folder to be updated
 * @param {string} parentFolderID - the id of the parent folder
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const updateFolderSuccess = (folderName, parentFolderID, payload) => ({
  type: UPDATE_FOLDER_REQUEST_FULFILLED,
  folderName,
  parentFolderID,
  payload
});

/**
 * trigger a request to get folder data for a certain folder
 * @param {string} folderID - the id of the folder
 * @returns {object} an action object
 */
export const getFolderRequest = folderID => ({
  type: GET_FOLDER_REQUESTED,
  folderID
});

/**
 * handle get folder request failure
 * @param {string} folderID - the id of the folder
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const getFolderFailure = (folderID, error) => ({
  type: GET_FOLDER_REQUEST_REJECTED,
  folderID,
  error
});

/**
 * handle get folder request success
 * @param {string} folderID - the id of the folder
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const getFolderSuccess = (folderID, payload) => ({
  type: GET_FOLDER_REQUEST_FULFILLED,
  folderID,
  payload: payload.data
});
